// extracted by mini-css-extract-plugin
export default {"link":"markdown_link__zLIk4","fade-in":"markdown_fade-in__7hUjQ"};